import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit, OnChanges {

  chartOption: any;
  @Input() pieChartData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotPieData();
      // this.chartOption?.resize();
    }, 1);
  }
  constructor() {
  }


  ngOnInit(): void { }

  ngOnChanges(): void {
    if (this.pieChartData?.pieData?.length) {
      this._plotPieData(); 
    }
  }

  private _plotPieData() {
    this.chartOption = {
      graphic: {
        type: 'text',
        left: 'center',
        bottom: 20,
        style: {
          text: this.pieChartData?.xAxisLabel,
          textAlign: 'center',
          textVerticalAlign: 'bottom',
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          fill: '#9291A5'
        }
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'horizontal',
        top: 'bottom',
        icon: 'circle',
        itemHeight: this.pieChartData?.legendHeight ? this.pieChartData?.legendHeight : 13,
        itemWidth: this.pieChartData?.legendWidth ? this.pieChartData?.legendWidth : 15,
        textStyle: {
          fontSize: 16,
          fontFamily: 'Inter',
          fontWeight: 500
        },
        padding: [0, 0, 50, 0],
        itemGap: 25
      },
      color: this.pieChartData?.color,
      series: [
        {
          type: 'pie',
          radius: this.pieChartData?.pieRadius ? this.pieChartData?.pieRadius : '75%',
          data: this.pieChartData?.pieData,
          label: {
            position: this.pieChartData?.labelPosition ? this.pieChartData?.labelPosition : 'inside',
            formatter: '{c}',
            color: '#fff',
            fontSize: 17,
            fontFamily: 'Inter',
            fontWeight: 700
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
  }

}
